import { X, UserCheck } from "lucide-react";
import { useSellerRef } from "@/context/SellerRefContext";

const SellerRefBanner = () => {
  const { seller, clearRef } = useSellerRef();
  if (!seller) return null;
  return (
    <div className="bg-blue-600 text-white text-sm py-2 px-4 flex items-center justify-center gap-3" data-testid="seller-ref-banner">
      <UserCheck className="w-4 h-4" />
      <span>Te atiende <strong>{seller.name}</strong> (cód. {seller.code})</span>
      <button onClick={clearRef} className="ml-2 p-1 rounded-full hover:bg-blue-700 transition-colors" aria-label="Quitar vendedor" data-testid="seller-ref-clear">
        <X className="w-3.5 h-3.5" />
      </button>
    </div>
  );
};

export default SellerRefBanner;
